document.addEventListener('DOMContentLoaded', () => {
  initWinFlow();
});

let step1Data = {};


function initWinFlow() {
  bindStep1();
  bindStep2();
  bindBillingToggle();
  bindBackButtons();
  bindRetryButton();
  initConsentValidation();
}

/* -----------------------------
   HELPERS
------------------------------ */

function showScreen(screenName) {
  document
    .querySelectorAll('.fb__panel')
    .forEach(panel => panel.classList.remove('is-active'));

  document
    .querySelector(`[data-screen="${screenName}"]`)
    ?.classList.add('is-active');
}

function validateDate(dateStr) {
  const parts = dateStr.split('/');

  if (parts.length !== 3) return false;

  const [m, d, y] = parts.map(Number);

  const date = new Date(y, m - 1, d);

  return (
    date.getMonth() === m - 1 &&
    date.getDate() === d &&
    date.getFullYear() === y
  );
}

function parseToUTC(dateStr) {
  if (!dateStr) return null;

  const [m, d, y] = dateStr.split('/');

  return new Date(
    Date.UTC(y, m - 1, d)
  ).toISOString();
}

function splitName(fullName) {
  const parts = fullName.trim().split(' ');

  return {
    firstName: parts[0] || '',
    lastName: parts.slice(1).join(' ') || ''
  };
}

function getItems(form) {
  const items = [];

  // selected test
  form.querySelectorAll(
    'input[name="product[]"]:checked'
  ).forEach(cb => {
    items.push({
      id: cb.dataset.variantId,
      qty: 1
    });
  });

  // cryo add-on
  const cryo = form.querySelector(
    'input[name="cryo_preservation"]:checked'
  );

  if (cryo?.dataset.variantId) {
    items.push({
      id: cryo.dataset.variantId,
      qty: 1
    });
  }

  return items;
}

/* -----------------------------
   STEP 1
------------------------------ */

function bindStep1() {
  const form = document.querySelector('[data-win-form]');

  if (!form) return;

  form.addEventListener('submit', e => {
    e.preventDefault();

    const formData = Object.fromEntries(
      new FormData(form)
    );

    const items = getItems(form);

    if (!validateDate(formData.date_of_birth)) {
      alert('Enter valid Date of Birth');
      return;
    }

    if (items.length === 0) {
      alert('Select a test');
      return;
    }

    step1Data = {
      employer_name: formData.employer_name, // Employer Name
      full_name: formData.full_name,
      member_id: null,
      date_of_birth: parseToUTC(
        formData.date_of_birth
      ),
      cycle_type: null,
      cycle_end_date: null,
      items
    };

    showScreen('win-step-2');
  });
}

/* -----------------------------
   BILLING
------------------------------ */

function bindBillingToggle() {
  const checkbox = document.querySelector(
    '.win-same-billing'
  );

  const billingFields =
    document.querySelector('.win-billing-fields');

  if (!checkbox || !billingFields) return;

  checkbox.addEventListener('change', () => {
    billingFields.style.display =
      checkbox.checked ? 'none' : 'block';
  });
}

/* -----------------------------
   PAYLOAD
------------------------------ */

function buildFinalPayload(
  step1Data,
  step2Data
) {
  const { firstName, lastName } =
    splitName(step1Data.full_name);

  const shippingAddress = {
    address1: step2Data.address,
    address2: step2Data.apt || '',
    city: step2Data.city,
    zip: step2Data.zip,
    country: step2Data.country,
    phone: step2Data.phone
  };

  const billingAddress =
    step2Data.same_billing === 'on'
      ? { ...shippingAddress }
      : {
          address1:
            step2Data.billing_address,
          city: step2Data.billing_city,
          zip: step2Data.billing_zip,
          country:
            step2Data.billing_country,
          phone:
            step2Data.billing_phone
        };

  return {
    entity:'win',
    customer: {
      firstName,
      lastName,
      email: step2Data.email,
      date_of_birth:
        step1Data.date_of_birth,
      phone: step2Data.phone
    },

    employerName: step1Data.employer_name, // employer name

    // memberId: null,

    shippingAddress,

    billingAddress,

    items: step1Data.items || [],

    // previousCycle: null
  };
}

/* -----------------------------
   API
------------------------------ */



async function submitWin(payload) {
  const response = await fetch(
    'https://api.sapyen.co/api/order/insurance/win',
    {
      method: 'POST',
      headers: {
        'Content-Type':
          'application/json',
           "x-api-key": "019df253-e564-7c88-9be6-786af0800aa6",
            //  'x-api-key':'super_secret_key'
      },
      body: JSON.stringify(payload)
    }
  );

  const result = await response.json();

  if (
    !response.ok ||
    result.success === false
  ) {
    throw result;
  }

  return result;
}

/* -----------------------------
   STEP 2
------------------------------ */

function bindStep2() {
  const form = document.querySelector(
    '[data-win-step-2]'
  );

  if (!form) return;

  form.addEventListener(
    'submit',
    async e => {
      e.preventDefault();

      const step2Data =
        Object.fromEntries(
          new FormData(form)
        );

      const payload =
        buildFinalPayload(
          step1Data,
          step2Data
        );

      try {
        showLoader();

        await submitWin(payload);

        showScreen('win-success');
      } catch (error) {
        document.querySelector(
          '[data-screen="win-error"] .fb__error-message'
        ).textContent =
          error?.message ||
          error?.error ||
          'Something went wrong while submitting your request.';

        showScreen('win-error');
      } finally {
        hideLoader();
      }
    }
  );
}

/* -----------------------------
   UI
------------------------------ */

function bindBackButtons() {
  document
    .querySelector(
      '[data-screen="win"] .fb__back'
    )
    ?.addEventListener('click', () =>
      showScreen('providers')
    );

  document
    .querySelector(
      '[data-screen="win-step-2"] .fb__back'
    )
    ?.addEventListener('click', () =>
      showScreen('win')
    );
}

function bindRetryButton() {
  document
    .querySelector(
      '[data-screen="win-error"] .fb__retry'
    )
    ?.addEventListener('click', () =>
      showScreen('win-step-2')
    );
}

function initConsentValidation() {
  const consent =
    document.getElementById(
      'winConsent'
    );

  const button =
    document.getElementById(
      'winContinueBtn'
    );

  if (!consent || !button) return;

  button.disabled = !consent.checked;

  consent.addEventListener(
    'change',
    () => {
      button.disabled =
        !consent.checked;
    }
  );
}